import portfolio1 from '../assets/images/Project/portfolio1.jpg';
import portfolio2 from '../assets/images//Project/portfolio2.jpg';
import portfolio3 from '../assets/images/Project/portfolio3.jpg'; 
import portfolio4 from '../assets/images/Project/portfolio4.jpg';
import portfolio5 from '../assets/images/Project/portfolio5.jpg'; 
import portfolio6 from '../assets/images/Project/portfolio6.jpg';
import portfolio7 from '../assets/images/Project/portfolio7.jpg';
import portfolio8 from '../assets/images/Project/portfolio8.jpg';
import portfolio9 from '../assets/images/Project/portfolio9.jpg';
import portfolio10 from '../assets/images/Project/portfolio10.jpg';

export const projects = [
    {
      id: 1,
      title: "E-Commerce Platform",
      description: "Custom online store with payment integration",
      image: portfolio1,
      tags: ["React", "Node.js", "MongoDB"],
      details: "Built a full-featured e-commerce platform with cart functionality, user authentication, and Stripe payment integration. Implemented admin dashboard for product management and order tracking.",
      client: "FashionHub",
      year: "2023"
    },
    {
      id: 2,
      title: "Healthcare Dashboard",
      description: "Patient management system for clinics",
      image: portfolio2,   
      tags: ["Angular", "Firebase", "Material UI"],
      details: "Developed HIPAA-compliant patient records management system with appointment scheduling, prescription management, and telemedicine features for a chain of clinics.",
      client: "MediCare Group",
      year: "2022"
    },
    {
      id: 3,
      title: "Mobile Banking App",
      description: "Secure banking application for Deskotop",
      image: portfolio3,
      tags: ["React Native", "Node.js", "AWS"],
      details: "Created a cross-platform mobile banking app with biometric authentication, fund transfer, bill payments, and spending analytics features for a regional bank.",
      client: "UrbanBank",
      year: "2023"
    },
    {
      id: 4,
      title: "ERP System",
      description: "Enterprise resource planning solution",
      image: portfolio4,
      tags: ["Vue.js", "Django", "PostgreSQL"],
      details: "Custom ERP system integrating inventory management, HR, accounting, and CRM modules for a manufacturing company with 500+ employees.",
      client: "SteelTech Industries",
      year: "2021"
    },
    {
      id: 5,
      title: "Fitness Tracker",
      description: "AI-powered workout companion",
      image: portfolio5,
      tags: ["Flutter", "TensorFlow", "Firebase"],
      details: "Developed fitness app with AI-powered workout recommendations, form correction using phone camera, and integration with wearables.",
      client: "FitAI",
      year: "2023"
    },
    {
      id: 6,
      title: "Smart Home App",
      description: "IoT controller for home automation",
      image: portfolio6,
      tags: ["React", "Python", "Raspberry Pi"],
      details: "Created cross-platform app to control IoT devices with voice commands, automation rules, and energy usage monitoring.",
      client: "HomeSmart Solutions",
      year: "2022"
    },
    {
      id: 7,
      title: "Food Delivery App",
      description: "Restaurant ordering and delivery platform",
      image: portfolio7,
      tags: ["React Native", "Node.js", "MongoDB"],
      details: "Built food delivery app with real-time order tracking, restaurant management dashboard, and delivery person tracking system.",
      client: "QuickBite",
      year: "2023"
    },
    {
      id: 8,
      title: "E-Learning Platform",
      description: "Online course marketplace",
      image: portfolio8,
      tags: ["Next.js", "Strapi", "PostgreSQL"],
      details: "Developed platform with course creation tools, video streaming, quizzes, and certification system serving 50,000+ students.",
      client: "LearnHub",
      year: "2022"
    },
    {
      id: 9,
      title: "Travel Booking System",
      description: "Hotel and flight booking engine",
      image: portfolio9,
      tags: ["React", "Node.js", "GraphQL"],
      details: "Created booking platform integrating multiple providers with price comparison, user reviews, and loyalty program features.",
      client: "TravelEase",
      year: "2021"
    },
    {
      id: 10,
      title: "Social Media Analytics",
      description: "Real-time social media monitoring",
      image: portfolio10,
      tags: ["React", "Python", "D3.js"],
      details: "Built dashboard for tracking social media metrics across platforms with sentiment analysis and competitor benchmarking.",
      client: "BrandMetrics",
      year: "2023"
    }
  ];